import React from 'react';
import Header from "../../components/Header/index";
import Footer from "../../components/Footer/Index";
import Graphique from "../../components/Bilan/index"
import CardPetiteDroite from '../../components/CardPetiteDroite';
import SousTitre from '../../components/SousTitre';
import ChiffreSousChiffre from '../../components/CardPetiteDroite/Chiffre';
import ListDeroule from '../../components/Form/ListDeroule';
import TitreH2 from '../../components/TitreH2/index';
import TitreBG from '../../components/TitreBG/index';
import image1 from "../../components/img/planet.png";
import image2 from "../../components/img/Trainbilan.png"
import logolegume from "../../components/img/Logolegume.png"
import logoAvion from "../../components/img/LogoAvion.png"
import Ligne1 from '../../components/Bilan/Ligne1';
import Ligne2 from '../../components/Bilan/Ligne2';
import Bouton from '../../components/Form/Bouton';
import CardBilan from '../../components/Bilan/CardBilan';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MapsUgcIcon from '@mui/icons-material/MapsUgc';
import Band1 from '../../components/Bilan/Band1';
import Band2 from '../../components/Bilan/Band2';
import CarreLogo from '../../components/CarreLogo/CarreLogo';
import BilanInter from '../../components/BilanInter';
import BilanFinal from '../../components/BilanInter/final';
import StepperLine from '../../components/StepperLine/index-test';
import html2canvas from 'html2canvas';
import { useRef, useState } from 'react';



const BilanPart4 = () => {
    const handleListDerouleChange = (selectedValue) => {
    // Logique de gestion du changement de valeur du ListDeroule
    console.log("ListDeroule value:", selectedValue);
    };
    const graphContainerRef = useRef(null);
    const [imageUrl, setImageUrl] = useState(null);

    const generateGraphImage = async () => {
        const node = graphContainerRef.current;
        if (node) {
            const canvas = await html2canvas(node, { scale: 2, useCORS: true });
            const imgUrl = canvas.toDataURL('image/jpeg');
            setImageUrl(imgUrl);
            return imgUrl;
        }
    };
    const totalConsumption = sessionStorage.getItem('totalConsumption') || 0;

    
    

    return (
    <div className='page'>     
        <div className="Header">
        <Header />
        </div>
        
        <div className='container-bas container'>
        <StepperLine />

        <div className='TitreBG'>
        <TitreBG Titre="Calculez vos émissions annuelles" className="titre"/>
        </div>
        <div className="row">

            <div className="col-10"    style={{marginTop : "2vh"}}>
                <TitreH2 Titre="Bilan de vos émissions annuelles" className="titre" couleur="#000000"/>
            </div>
            
        </div>

        <div className="row">
            
            <div className="col-9" style={{marginBottom : "2vh"}}>
                <h1 className = "h31">Le bilan détaillé de mes émissions </h1>
            </div>
            
            </div>

            <div className="row">
                <BilanFinal numeroEtape={8} voyage="non" />
            </div>
            <div className='row' style={{marginTop : "2vh"}}>
                <div className='col-12'>
                <CardBilan totalConsumption={totalConsumption}/>
                </div>
            </div>
            <div className="row">
            <div className="row col-12 band-wrapper-bilan" style={{marginTop: "1vh",marginLeft: "0vw"}}>
                <Band1 generateGraphImage={generateGraphImage} totalConsumption={totalConsumption}/>


            </div>
            </div>
            
            

        </div>
    
    </div>
    );
};

export default BilanPart4;

